function userJoinToLessonEventAdapter(data) {
  const {
    peerId,
    id,
    name,
    fullName,
    isTeacher,
    is_teacher: isTeacherSnakeCase,
    userId,
    user_id: userIdSnakeCase,
  } = data.lesson.room.peer;

  return {
    peerId: peerId ?? id,
    name: name || fullName || 'Неизвестное имя',
    userId: userId ?? userIdSnakeCase ?? null,
    isTeacher: isTeacher ?? isTeacherSnakeCase ?? false,
    adapted: true,
  };
}

export default userJoinToLessonEventAdapter;
